<template>
	<div class="content-wrap">
		<template>
			<a-form-model
				layout="inline"
				:label-col="{ span: 8 }"
				:wrapper-col="{ span: 16 }"
				class="customer-list-form"
				:colon="false"
			>
				<a-form-model-item :label="$t('businessDispatch.plateNumber')">
					<a-auto-complete
						v-model.trim="params.condition.plateNumber"
						:placeholder="$t('businessDispatch.plateNumber')"
						size="small"
						:allowClear="true"
						:data-source="dataSourcePlateNumber"
						@change="onChangePlateNumber"
					/>
				</a-form-model-item>
				<a-form-model-item :label="$t('businessDispatch.vehicleType')">
					<a-select
						allowClear
						style="width: 150px"
						size="small"
						v-model="params.condition.plateType"
						:placeholder="$t('businessDispatch.vehicleType')"
					>
						<a-select-option value="CTN_TRUCK">
							{{ $t('truckList.setTruck') }}
						</a-select-option>
						<a-select-option value="OTHER_TRUCK">
							{{ $t('truckList.otherCarsType') }}
						</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item>
					<a-button
						type="primary"
						@click="search"
						size="small"
						style="marginLeft:10px;"
					>
						{{ $t('search') }}
					</a-button>
				</a-form-model-item>
				<a-form-model-item>
					<a-button @click="resetTruck" size="small">
						{{ $t('reset') }}
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</template>
		<a-modal
			:title="isAdd ? $t('truckList.addVehicleInfo') : $t('truckList.updateVehicleInfo')"
			:visible="visible_truckrform"
			@cancel="canceltruckrform"
		>
			<a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-item :label="$t('businessDispatch.plateNumber')">
					<a-input
						allowClear
						style="width: 150px"
						v-model.trim="addtruckreq.plateNumber"
						:placeholder="$t('businessDispatch.plateNumber')"
						v-decorator="[
							'note',
							{
								rules: [{ required: true, message: $t('businessDispatch.plateNumber') }],
							},
						]"
					>
					</a-input>
				</a-form-item>
				<a-form-item :label="$t('businessDispatch.vehicleType')">
					<a-select
						allowClear
						style="width: 150px"
						v-model="addtruckreq.plateType"
						:placeholder="$t('businessDispatch.vehicleType')"
						v-decorator="[
							'note',
							{
								rules: [{ required: true, message: $t('businessDispatch.vehicleType') }],
							},
						]"
					>
						<a-select-option value="CTN_TRUCK">
							{{ $t('truckList.setTruck') }}
						</a-select-option>
						<a-select-option value="OTHER_TRUCK">
							{{ $t('truckList.otherCarsType') }}
						</a-select-option>
					</a-select>
				</a-form-item>
			</a-form>
			<template slot="footer" v-if="isAdd">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading_truck"
					@click="oktruck"
				>
					{{ $t('sure') }}
				</a-button>
				<a-button key="back" @click="resettruck">
					{{ $t('reset') }}
				</a-button>
			</template>
			<template slot="footer" v-if="!isAdd">
				<a-button
					key="submit"
					type="primary"
					:loading="confirmLoading_truck"
					@click="oktruck"
				>
					{{ $t('update') }}
				</a-button>
				<a-button key="back" @click="resettruck">
					{{ $t('reset') }}
				</a-button>
			</template>
		</a-modal>

		<!-- table展示 -->
		<div class="table-area">
			<table-fixed
				:tableData="tableData"
				:tableColumn="columns"
				:columnSettingsKey="$route.name"
				:pagination="pagination"
				:loading="loading"
			>
				<template v-slot:toolbar>
					<a-button type="primary" size="small" @click="showtruck">
						{{ $t('truckList.addVehicleInfo') }}
					</a-button>
				</template>
				<template v-slot:option="scope">
					<a-button @click="showUpdate(scope.truck)">{{ $t('edit') }}</a-button>
				</template>
			</table-fixed>
		</div>
	</div>
</template>
<script>
import tableFixed from "../../components/table-fixed.vue";
import { trucklist, addTruck, updateTruck } from "../../api/basicData";
import { columns } from "./truck-list";
import { searchReqParam } from "../../utils/searchReqParam";

export default {
	name: "business-dispatch",
	components: { tableFixed },
	data() {
		return {
			columns,
			req: searchReqParam(),
			tableData: [],
			params: {
				condition: {
					companyId: "",
					id: "",
					plateNumber: "",
					plateType: undefined,
				},
				page: 1,
				pageSize: 10,
			},
			pagination: {
				showSizeChanger: true,
				defaultPageSize: 10,
				pageSizeOptions: ["10", "15", "50", "100"],
				total: 0,
				current: 1,
				showTotal: (total) => this.$t('totalText', { total }),
				onChange: (page) => {
					this.pagination.current = page;
					this.req.params.page = page;
					this.pageInit();
				},
				onShowSizeChange: (current, pageSize) => {
					this.pagination.current = 1;
					this.req.params.page = 1;
					this.req.params.pageSize = pageSize;
					this.pageInit();
				},
			},
			loading: false,
			visible_truckrform: false,
			confirmLoading_truck: false,
			addtruckreq: {
				companyId: "",
				currentUserId: "",
				plateNumber: undefined,
				plateType: undefined,
			},
			isAdd: false,
			initTruckreq: {},
			dataSourcePlateNumber: [],
		};
	},
	created() {},
	mounted() {
		this.pageInit();
	},
	methods: {
		pageInit() {
			this.req.params = this.params;
			this.loading = true;
			trucklist(this.req).then((res) => {
				let resData = JSON.parse(res.data);
				if (!resData.success || resData.code != "0") {
					this.$message.error(resData.msg);
					return;
				}
				this.tableData = resData.data.list;
				this.pagination.total = resData.data.total;
				this.loading = false;
			});
		},
		showtruck() {
			this.isAdd = true;
			// 新增时的初始化数据
			this.initTruckreq = {
				companyId: "",
				currentUserId: "",
				plateNumber: undefined,
				plateType: undefined,
			};
			this.addtruckreq = {
				companyId: "",
				currentUserId: "",
				plateNumber: undefined,
				plateType: undefined,
			};
			this.visible_truckrform = true;
		},
		canceltruckrform() {
			this.visible_truckrform = false;
			this.confirmLoading_truck = false;
		},
		resettruck() {
			// 重置表单数据
			this.addtruckreq = {
				...this.initTruckreq,
			};
		},
		oktruck() {
			// plateNumber
			if (
				this.addtruckreq.plateNumber == "" ||
				this.addtruckreq.plateNumber == undefined
			) {
				this.$message.error(this.$t('businessDispatch.plateNumberCannotBeEmpty'));
				return;
			}
			// if (
			// 	this.addtruckreq.plateNumber.length > 8 ||
			// 	this.addtruckreq.plateNumber.length < 6
			// ) {
			// 	this.$message.error("车牌号长度应为7-8位");
			// 	return;
			// }
			// plateType
			if (
				this.addtruckreq.plateType == "" ||
				this.addtruckreq.plateType == undefined
			) {
				this.$message.error(this.$t('truckList.pleaseSelectCarModel'));
				return;
			}
			this.req.params = this.addtruckreq;
			// 新增
			if (this.isAdd) {
				addTruck(this.req).then((res) => {
					let result = JSON.parse(res.data);
					console.log(result);
					if (!result.success) {
						this.$message.error(result.msg);
						return
					}
					if (result.code == "0") {
						// 成功提示信息
						this.$message.success(result.msg);
						this.visible_truckrform = false;
						// 重置
						// this.resettruck();
						// 通知父单元成功消息
						this.pageInit();
					} else if (result.code == "dat-TRUCK_PLATE_EXISTS") {
						this.$message.error(result.msg);
					} else {
						this.$emit("success", result.msg);
					}
				});
				return;
			}
			// 更新
			updateTruck(this.req).then((res) => {
				console.log(res.data);
				let result = JSON.parse(res.data);
				console.log(result);
				if (result.code == "0") {
					// 成功提示信息
					this.$message.success(result.msg);
					this.visible_truckrform = false;
					// 重置
					// this.resettruck();
					// 通知父单元成功消息
					this.pageInit();
				} else if (result.code == "dat-TRUCK_PLATE_EXISTS") {
					this.$message.error(result.msg);
				} else {
					this.$emit("success", result.msg);
				}
			});
		},
		showUpdate(truck) {
			console.log(truck);
			this.isAdd = false;
			this.initTruckreq = {
				companyId: truck.companyId,
				currentUserId: "",
				id: truck.id,
				plateNumber: truck.plateNumber,
				plateType: truck.plateType,
			};
			this.addtruckreq = {
				companyId: truck.companyId,
				currentUserId: "",
				id: truck.id,
				plateNumber: truck.plateNumber,
				plateType: truck.plateType,
			};
			this.visible_truckrform = true;
		},
		// 搜索
		search() {
			this.pagination.onChange(1); 
		},
		// 重置
		resetTruck() {
			this.req.params.condition = {};
		},
		onChangePlateNumber(searchText) {
			trucklist(this.req).then((res) => {
				let temp = JSON.parse(res.data).data.list;
				this.dataSourcePlateNumber = [];
				temp.forEach((item) => {
					if (this.dataSourcePlateNumber.indexOf(item.plateNumber) == -1) {
						this.dataSourcePlateNumber.push(item.plateNumber);
					}
				});
				this.dataSourcePlateNumber = !searchText
					? []
					: this.dataSourcePlateNumber;
			});
		},
	},
};
</script>

<style lang="less" scoped></style>
